import React from 'react';
import MyTasksCommon from '../_myTasksCommon';

export default props => <MyTasksCommon {...props} />;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyAllTasksList/MyAllTasksList.js